export const menuList =  [
    {
        "id": "1.1",
        "form_no": "1.1",
        "form_name": "Teaching and Evaluation/Supervision",
        "next": "1.2"
    },
    {
        "id": "1.2",
        "form_no": "1.2",
        "form_name": "Course Activity and Documentation",
        "next": "1.3",
        "prev": "1.1"
    },
    {
        "id": "1.3",
        "form_no": "1.3",
        "form_name": "Student Advising and Counselling",
        "next": "2.1",
        "prev": "1.2"
    },
    {
        "id": "2.1",
        "form_no": "2.1",
        "form_name": "Research Outcomes",
        "next": "2.2",
        "prev": "1.3"
    },
    {
        "id": "2.2",
        "form_no": "2.2",
        "form_name": "Research/Academic Grants",
        "next": "2.3",
        "prev": "2.1"
    },
    {
        "id": "2.3",
        "form_no": "2.3",
        // "form_name": "Commissioned Research",
          "form_name": "Externally Funded Research",
        "next": "2.4",
        "prev": "2.2"
    },
    {
        "id": "2.4",
        "form_no": "2.4",
        "form_name": "Conference/Seminar/Training",
        "next": "2.5",
        "prev": "2.3"
    },
    {
        "id": "2.5",
        "form_no": "2.5",
        "form_name": "Research Positions/Fellowship/Membership",
        "next": "3.1",
        "prev": "2.4"
    },
    {
        "id": "3.1",
        "form_no": "3.1",
        "form_name": "Academic Roles and Responsibilities",
        "next": "3.2",
        "prev": "2.5"
    },
    {
        "id": "3.2",
        "form_no": "3.2",
        "form_name": "Co-Curricular and Extra Curricular Roles and Responsibilities",
        "prev": "3.1"
    }
]